import './camera-capture-shell.css';

/**
 * Shown while getUserMedia is starting — avoids Android WebView blank video preview.
 */
export default function CameraPrepPlaceholder({
  variant = 'lux',
  message = 'Preparing camera…',
}) {
  return (
    <div
      className={`camera-capture-shell camera-capture-shell--${variant}`}
      role="status"
      aria-live="polite"
      aria-label={message}
    >
      <div className="camera-capture-shell__content">
        <div className="camera-capture-shell__spinner" aria-hidden="true" />
        <p className="camera-capture-shell__text">{message}</p>
      </div>
    </div>
  );
}
